import { Field } from '@sitecore-jss/sitecore-jss-nextjs';

import { icon_search } from '@gn-audio/icons';
import { JabraIcon } from '@gn-audio/jss-components';

type PartnerLocatorSearchbarProps = {
  nameSearchPlaceholder: Field<string>;
  addressSearchPlaceholder: Field<string>;
  searchCompanyValue: string;
  searchAddressValue: string;
  setSearchCompanyValue: (value: string) => void;
  setSearchAddressValue: (value: string) => void;
};

export const PartnerLocatorSearchbar = ({
  nameSearchPlaceholder,
  addressSearchPlaceholder,
  searchCompanyValue,
  searchAddressValue,
  setSearchCompanyValue,
  setSearchAddressValue,
}: PartnerLocatorSearchbarProps) => {
  return (
    <div className="mb-4 flex flex-col gap-3 md:flex-row">
      <div className="relative w-full md:w-1/2">
        <JabraIcon
          className="absolute left-2 top-1/2 h-6 w-6 -translate-y-1/2 transform"
          Icon={icon_search}
          aria-hidden="true"
        />
        <input
          name="search-company"
          type="search"
          className="w-full rounded-md border border-gray-300 py-2 pl-10 pr-2"
          placeholder={nameSearchPlaceholder?.value}
          value={searchCompanyValue}
          onChange={(e) => setSearchCompanyValue(e.target.value)}
        />
      </div>
      <div className="relative w-full md:w-1/2">
        <JabraIcon
          className="absolute left-2 top-1/2 h-6 w-6 -translate-y-1/2 transform"
          Icon={icon_search}
          aria-hidden="true"
        />
        <input
          name="search-address"
          type="search"
          className="w-full rounded-md border border-gray-300 py-2 pl-10 pr-2"
          placeholder={addressSearchPlaceholder?.value}
          value={searchAddressValue}
          onChange={(e) => setSearchAddressValue(e.target.value)}
        />
      </div>
    </div>
  );
};
